<script setup lang="ts">
import { ConfirmProvider, ToastProvider, ToastViewport } from 'catalyst-vue'
</script>

<template>
  <ToastProvider>
    <ConfirmProvider default-confirm-label="確認" default-cancel-label="取消" default-alert-label="知道了">
      <RouterView />
    </ConfirmProvider>
    <ToastViewport />
  </ToastProvider>
</template>
